import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';

export const GET_WISHLIST_ITEM_REQUEST = 'GET_WISHLIST_ITEM_REQUEST';
export const GET_WISHLIST_ITEM_SUCCESS = 'GET_WISHLIST_ITEM_SUCCESS';
export const GET_WISHLIST_ITEM_ERROR = 'GET_WISHLIST_ITEM_ERROR';
export const RESET_WISHLIST_ITEM_DATA = 'RESET_WISHLIST_ITEM_DATA';

export function getWishlistedItemRequestAction(products) {
	return { type: GET_WISHLIST_ITEM_REQUEST, products };
}

export function getWishlistedItemSuccessAction(data, products) {
	return { type: GET_WISHLIST_ITEM_SUCCESS, data, products };
}

export function getWishlistedItemErrorAction(error, products) {
	return { type: GET_WISHLIST_ITEM_ERROR, error, products };
}

export function fetchWishlistSummaryAction(products) {
	return dispatch => {
		dispatch(getWishlistedItemRequestAction(products));

		const payload = {
			requestContext: { products }
		};
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/product/summary'
			}),
			payload
		).then(
			json => dispatch(getWishlistedItemSuccessAction(json['RESPONSE'], products)),
			err => {
				dispatch(getWishlistedItemErrorAction(err, products));
				return Promise.reject(err);
			}
		);
	};
}
export function resetWishlistItemDataAction() {
	return dispatch => {
		return dispatch({ type: RESET_WISHLIST_ITEM_DATA });
	};
}
